import React, { useEffect, useState } from "react";
import { loader } from "graphql.macro";
import { useScreenType } from "../../../hooks/useScreenType";
import { AbsoluteCenter } from "../../AbsoluteCenter";
import { ButtonWithSound } from "../../AudioProvider";
import closeIcon from "./assets/close-icon.png";
import styles from "./InstantTournaments.module.scss";
import classNames from "classnames";
import Slider from "react-slick";
import blueAarrowLeft from "./assets/slider-left.png";
import blueAarrowLeftHover from "./assets/slider-left-hover.png";
import titleImage from "./assets/new_tournament.png";
import tournamentNameIcon from "./assets/tournament_name.png";
import tournamentTypeIcon from "./assets/tournament_type.png";
import tournamentPlayersIcon from "./assets/tournament_users.png";
import tournamentImageIcon from "./assets/tournament_image.png";
import giftIcon from "./assets/gift.png";
import { Image } from "../../Image";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { NewButtonsSelect } from "./NewButtonsSelect";
import addAvatar from "./assets/preview-img.png";
import bgImage1 from "./assets/bg-image-1.png";
import coin from "./assets/coin.png";
import knife from "./assets/knife.png";
import { useQuery } from "../../../hooks/useQuery";
import {
  InstantTournamentTemplatesQuery,
  InstantTournamentTemplatesQueryVariables,
} from "./AddInstantTournament.generated";

import {
  CreateInstantTournamentMutation,
  CreateInstantTournamentMutationVariables,
} from "./graphql/InstantTournamentCreateMutation.generated";
import { useMutation } from "../../../hooks/useMutation";
import {
  TournamentPlayerPerTeam,
  TournamentType,
} from "../../../graphql/generated";
import { InstantTournamentTemplateType } from "./types";
import { Loader } from "../../Loader";
import { useHistory } from "react-router-dom";
import {
  GetInstantTournamentImageFileNamesQuery,
  GetInstantTournamentImageFileNamesQueryVariables,
} from "./graphql/TournamentsLogoQuery.generated";
import * as Sentry from "@sentry/browser";

const INSTANT_TOURNAMENT_TEMPLATES = loader(
  "./graphql/InstantTournamentsTemplateQuery.graphql"
);

const TOURNAMENT_IMAGES = loader("./graphql/TournamentsLogoQuery.graphql");

const INSTANT_TOURNAMENT_CREATE_MUTATION = loader(
  "./graphql/InstantTournamentCreateMutation.graphql"
);

const PopupContainer = ({ children }: { children?: React.ReactNode }) => {
  const screenType = useScreenType();

  return (
    <div className="absolute bg-black-alpha-30 top-0 left-0 right-0 bottom-0 z-50">
      {screenType === "DESKTOP" ? (
        <AbsoluteCenter>{children}</AbsoluteCenter>
      ) : (
        <div className="flex justify-center items-center h-screen">
          {children}
        </div>
      )}
    </div>
  );
};

const CloseButton = ({ closeHandler }: { closeHandler: () => void }) => {
  return (
    <div className="flex justify-center">
      <ButtonWithSound className="btn btn-lg p-0" onClick={closeHandler}>
        <button
          onClick={() => {
            closeHandler();
          }}
        >
          <img src={closeIcon} alt="close" />
        </button>
      </ButtonWithSound>
    </div>
  );
};

const Arrow = (props: any) => {
  const { className, style, onClick } = props;
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <Image
        src={hovered ? props.image : props.imageHovered}
        alt="arrow"
        className={classNames(props.customStyleClass, {
          ...className,
        })}
        style={{ zIndex: props?.zIndex, ...style }}
      />
    </div>
  );
};

const SlickSlider = React.memo(
  ({
    shouldSlide,
    doShowArrows,
    templateChange,
    children,
  }: {
    shouldSlide: boolean;
    doShowArrows: boolean;
    templateChange: (index: number) => void;
    children?: React.ReactNode;
  }) => {
    if (shouldSlide) {
      let slider: Slider | null = null;
      const onNext = () => {
        slider?.slickNext();
      };

      const onPrev = () => {
        slider?.slickPrev();
      };
      const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (currentSlide: number) => {
          templateChange(currentSlide);
        },
      };
      return (
        <div className="relative rounded-lg overflow-hidden">
          {doShowArrows && (
            <Arrow
              image={blueAarrowLeft}
              imageHovered={blueAarrowLeftHover}
              customStyleClass={styles.prevArrow}
              onClick={onPrev}
              zIndex={1}
            />
          )}
          {doShowArrows && (
            <Arrow
              image={blueAarrowLeft}
              imageHovered={blueAarrowLeftHover}
              customStyleClass={styles.nextArrow}
              onClick={onNext}
              zIndex={1}
            />
          )}

          <Slider ref={(c) => (slider = c)} {...sliderSettings}>
            {children}
          </Slider>
        </div>
      );
    }

    return <div>{children}</div>;
  }
);

enum types {
  publicTournament = "Public",
  privateTournament = "Private",
}

enum formatText {
  ONE_VS_ONE = "1 x 1",
  TWO_VS_TWO = "2 x 2",
}

enum players {
  eight = "8",
  sixteen = "16",
  thirtytwo = "32",
  sixtyfour = "64",
  hundredtwentyeight = "128",
}

export const AddInstantTournament = ({
  closeHandler,
  section,
}: {
  closeHandler: () => void;
  section: { sectionId: string; tableId: string };
}) => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [tournamentCurrentTemplate, setTournamentCurrentTemplate] = useState<
    InstantTournamentTemplateType
  >();
  const [tournamentImage, setTournamentImage] = useState("");
  const [activeImage, setActiveImage] = useState("");
  const [selectImageView, setSelectImageView] = useState(false);

  const [, createInstantTournament] = useMutation<
    CreateInstantTournamentMutation,
    CreateInstantTournamentMutationVariables
  >(INSTANT_TOURNAMENT_CREATE_MUTATION, false);

  const filterData = React.useMemo(() => {
    return {
      roomId: section?.sectionId,
      gameId: section?.tableId,
    };
  }, [section]);

  const [{ data, fetching }] = useQuery<
    InstantTournamentTemplatesQuery,
    InstantTournamentTemplatesQueryVariables
  >({
    query: INSTANT_TOURNAMENT_TEMPLATES,
    variables: {
      filter: {
        roomId: filterData.roomId,
        gameId: filterData.gameId,
      },
    },
  });

  const [{ data: tournamentLogos, fetching: fetchingLogos }] = useQuery<
    GetInstantTournamentImageFileNamesQuery,
    GetInstantTournamentImageFileNamesQueryVariables
  >({
    query: TOURNAMENT_IMAGES,
  });

  useEffect(() => {
    if (!!data?.instantTournamentTemplates?.length) {
      setTournamentCurrentTemplate(data?.instantTournamentTemplates[0]);
    }
  }, [data]);

  const templateChange = (index: number) => {
    if (data?.instantTournamentTemplates?.length) {
      setTournamentCurrentTemplate(data?.instantTournamentTemplates[index]!);
    }
  };

  const getMaxValue = (index: number) => {
    const awards = data?.instantTournamentTemplates?.[index]?.awards || [];
    const maxValue = Math.max(...awards.map((a) => a.amount.value));

    return maxValue;
  };

  const validationSchema = React.useMemo(
    () =>
      Yup.object().shape({
        tournamentName: Yup.string().required(t("name_required_field")),
        tournamentType: Yup.string().required(),
        tournamentPlayers: Yup.string().required(),
        tournamentImage: Yup.string().required(
          t("instant_tournament.select_image")
        ),
      }),
    []
  );

  const changeModalView = () => {
    setSelectImageView(false);
    setActiveImage("");
  };

  const handleSetSelectedImage = () => {
    setSelectImageView(false);
    setTournamentImage(activeImage);
    setActiveImage("");
  };

  return fetching || fetchingLogos ? (
    <AbsoluteCenter>
      <Loader description={t("loading_tournament")} />
    </AbsoluteCenter>
  ) : (
    <PopupContainer>
      <Formik
        initialValues={{
          tournamentName: "",
          tournamentType: "Public",
          tournamentPlayers: "8",
          tournamentImage: "",
          playersPerTeam: "ONE_VS_ONE",
        }}
        validationSchema={validationSchema}
        validate={(values) => {
          const errors: { [key: string]: string | undefined } = {};

          if (!values.tournamentName)
            errors.tournamentName = t("name_required_field");
          return errors;
        }}
        onSubmit={(values) => {
          createInstantTournament({
            input: {
              instantTournamentTemplateId: tournamentCurrentTemplate?.id!,
              name: values.tournamentName,
              imageFileName: values.tournamentImage,
              numberOfPlayers: +values.tournamentPlayers,
              timeWaitingToJoinPlayers: +tournamentCurrentTemplate?.timeWaitingToJoinPlayers!,
              type:
                values.tournamentType === "Private"
                  ? TournamentType.Private
                  : TournamentType.Public,
            },
          }).then((result) => {
            if (result.error) {
              Sentry.captureMessage(
                "Error on create instant tournament: tournamentTemplateId:" +
                  tournamentCurrentTemplate?.id +
                  ", roomId: " +
                  filterData.roomId +
                  ", gameId: " +
                  filterData.gameId
              );
              return result.error;
            } else {
              push(
                `/area/${filterData.roomId}:${filterData.gameId}/instant-tournaments/${result.data?.createInstantTournament?.id}`
              );
              closeHandler();
            }
          });
        }}
      >
        {({
          values,
          isValid,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          handleSubmit,
        }) => {
          return (
            <form onSubmit={handleSubmit} className="flex flex-col h-full">
              <div
                className={classNames(
                  "flex",
                  "flex-col",
                  "gap-6",
                  styles.addTournament
                )}
              >
                <div
                  className={classNames(
                    "flex justify-between items-center px-8 pt-3 pb-2 gap-8",
                    styles.top
                  )}
                >
                  {selectImageView ? (
                    <div className="flex items-center gap-3">
                      <span className="text-white text-2xl font-semibold">
                        {t("instant_tournament.select_image")}
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-center gap-3">
                      <img
                        width={68}
                        height={52}
                        src={titleImage}
                        alt="New tournament"
                      />
                      <span className="text-white text-2xl font-semibold">
                        {t("instant_tournament.new_instant_tournament")}
                      </span>
                    </div>
                  )}

                  <CloseButton
                    closeHandler={
                      selectImageView ? changeModalView : closeHandler
                    }
                  />
                </div>
                {selectImageView ? (
                  <div
                    className={classNames(
                      "grid grid-cols-5 px-8 py-6 gap-8",
                      styles.imageSection
                    )}
                  >
                    {tournamentLogos?.instantTournamentImageFileNames?.map(
                      (logo) => {
                        return (
                          <div
                            className={styles.selectImage}
                            style={{
                              background:
                                logo === activeImage
                                  ? "linear-gradient(180deg, #ffaa37 0%, #ff7600 100%)"
                                  : "#2A3F73",
                            }}
                          >
                            <div
                              className="rounded-md cursor-pointer"
                              onClick={() => {
                                setActiveImage(logo);
                              }}
                            >
                              <img
                                width="100%"
                                height="100%"
                                src={`${process.env.REACT_APP_API_HOST}/instant-tournaments/${logo}`}
                                alt=""
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <>
                    <div className="px-8">
                      <SlickSlider
                        shouldSlide={true}
                        doShowArrows={
                          (data?.instantTournamentTemplates?.length || 0) > 1
                        }
                        templateChange={templateChange}
                      >
                        {data?.instantTournamentTemplates?.map(
                          (template, index) => {
                            return (
                              <div key={template.id}>
                                <div
                                  className={classNames(
                                    "w-full flex flex-col relative rounded-lg overflow-hidden",
                                    styles.slider
                                  )}
                                >
                                  <img
                                    src={bgImage1}
                                    alt=""
                                    className="absolute object-cover"
                                  />
                                  <div
                                    className={`flex z-10 text-white text-center h-full pb-4 ${
                                      template.customAward?.length
                                        ? "flex-col justify-end items-center gap-2"
                                        : "gap-4 justify-center items-end"
                                    }`}
                                  >
                                    {template.customAward?.length ? (
                                      <div
                                        className="flex flex-col gap-2 text-white text-sm font-semibold"
                                        style={{ maxWidth: "430px" }}
                                      >
                                        <div className="flex items-center justify-center gap-2 py-1 px-6">
                                          <img
                                            width={18}
                                            height={21}
                                            src={giftIcon}
                                            alt=""
                                          />
                                          <span>{template.customAward}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="flex flex-col gap-2">
                                        <span className={styles.topPriceTitle}>
                                          {t("instant_tournament.top_price")}
                                        </span>
                                        <div
                                          className={classNames(
                                            "flex items-center justify-center gap-2 py-1 px-6 text-xs",
                                            styles.topPrice
                                          )}
                                        >
                                          <img src={coin} alt="" />
                                          <span>{getMaxValue(index)}</span>
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex gap-4 z-10 justify-center text-center">
                                      <div className="flex flex-col gap-2">
                                        <span
                                          className={classNames(
                                            "text-xs",
                                            styles.topPriceTitle
                                          )}
                                        >
                                          {t("instant_tournament.match_type")}
                                        </span>
                                        <div
                                          className={classNames(
                                            "flex items-center justify-center gap-2 py-1 px-6",
                                            styles.topPrice
                                          )}
                                        >
                                          <img src={knife} alt="" />
                                          <span>
                                            {template.playerPerTeam ===
                                            TournamentPlayerPerTeam.OneVsOne
                                              ? formatText.ONE_VS_ONE
                                              : formatText.TWO_VS_TWO}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <span className="text-white absolute ml-4 mt-4 text-base">{`${
                                    index + 1
                                  }/${
                                    data?.instantTournamentTemplates?.length
                                  }`}</span>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </SlickSlider>
                    </div>
                    <div className="px-8 flex flex-col w-full gap-4">
                      <div className="flex items-center gap-4">
                        <div className="w-5/12 flex items-center gap-3">
                          <img
                            width={20}
                            src={tournamentNameIcon}
                            alt="tournament name"
                          />
                          <span className="text-white uppercase font-bold">
                            {t("instant_tournament.tournament_name")}
                          </span>
                        </div>
                        <div className="w-7/12">
                          <input
                            name="tournamentName"
                            onChange={(e) => {
                              setFieldTouched("tournamentType", true);
                              setFieldValue("tournamentName", e.target.value);
                            }}
                            placeholder={""}
                            className="form-input rounded-lg py-1 px-3  text-sm shadow-xl w-full"
                            type="text"
                            value={values.tournamentName}
                          />
                          <ErrorMessage
                            name="tournamentName"
                            className="mt-2 font-bold text-red-600"
                            component="div"
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="w-5/12 flex items-center gap-3">
                          <img
                            width={20}
                            src={tournamentTypeIcon}
                            alt="tournament type"
                          />
                          <span className="text-white uppercase font-bold">
                            {t("instant_tournament.tournament_type")}
                          </span>
                        </div>
                        <div className="w-7/12 flex">
                          <NewButtonsSelect
                            key="tournamentType"
                            className="flex gap-3 w-1/2"
                            disabled={isSubmitting}
                            value={values.tournamentType}
                            options={Object.values(types).map((value) => ({
                              id: value,
                              name: t(`${value.toLowerCase()}`),
                            }))}
                            onChange={(value) => {
                              setFieldTouched("tournamentType", true);
                              setFieldValue("tournamentType", value.id);
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="w-5/12 flex items-center gap-3">
                          <img
                            width={20}
                            src={tournamentPlayersIcon}
                            alt="tournament type"
                          />
                          <span className="text-white uppercase font-bold">
                            {t("players")}
                          </span>
                        </div>
                        <div className="w-7/12">
                          <NewButtonsSelect
                            key="tournamentPlayers"
                            className="flex gap-2 w-1/2"
                            disabled={isSubmitting}
                            value={values.tournamentPlayers}
                            options={Object.values(players).map((value) => ({
                              id: value,
                              name: value,
                            }))}
                            onChange={(value) => {
                              setFieldTouched("tournamentPlayers", true);
                              setFieldValue("tournamentPlayers", value.id);
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="w-5/12 flex items-center gap-3">
                          <img
                            width={20}
                            src={tournamentImageIcon}
                            alt="tournament image"
                          />
                          <span className="text-white uppercase font-bold">
                            {t("instant_tournament.tournament_image")}
                          </span>
                        </div>
                        <div className="w-7/12 flex flex-col">
                          <div className="flex items-center gap-3">
                            <div className={styles.addImage}>
                              <img
                                className={styles.addImage}
                                src={
                                  tournamentImage
                                    ? `${process.env.REACT_APP_API_HOST}/instant-tournaments/${tournamentImage}`
                                    : addAvatar
                                }
                                alt="Add avatar"
                                draggable={false}
                              />
                            </div>
                            <div className="flex flex-col gap-2">
                              <button
                                onClick={() => setSelectImageView(true)}
                                className="btn btn-green-600 rounded-lg gap-2 px-6 flex-shrink-0 cursor-pointer text-white text-center"
                              >
                                {t("instant_tournament.select_image")}
                              </button>
                            </div>
                          </div>
                          <ErrorMessage
                            name="tournamentImage"
                            className="mt-2 font-bold text-red-600"
                            component="div"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="flex items-center justify-center relative transform translate-y-1/2 mt-auto">
                  {selectImageView ? (
                    <div
                      className={classNames(
                        "btn w-5/12 btn-blue-600 rounded-lg gap-2 px-6 flex-shrink-0 text-xl",
                        {
                          "pointer-events-none": !activeImage,
                          "cursor-pointer": activeImage,
                        }
                      )}
                      onClick={(e) => {
                        setFieldValue("tournamentImage", activeImage);
                        handleSetSelectedImage();
                      }}
                    >
                      {t("instant_tournament.select_image")}
                    </div>
                  ) : (
                    <ButtonWithSound
                      type="submit"
                      disabled={false}
                      className="btn w-5/12 btn-blue-600 rounded-lg gap-2 px-6 flex-shrink-0 text-xl"
                    >
                      {t("instant_tournament.create_tournament")}
                    </ButtonWithSound>
                  )}
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </PopupContainer>
  );
};
